import Vue from "vue";

// Which driver experience a driver has chosen: "old" (/driver, the default) or "new"
// (/driver-new and its pages). Kept in localStorage so it takes effect straight away and
// survives reloads; every link to a driver page goes through driverHomePath() or the router
// guard in router.js.
const KEY = "driverExperience";

function load() {
  try {
    return localStorage.getItem(KEY) === "new" ? "new" : "old";
  } catch (e) {
    return "old"; // storage can be unavailable (private mode)
  }
}

// reactive, so components showing the choice update the moment it changes
export const driverExperience = Vue.observable({ value: load() });

export function setDriverExperience(value) {
  driverExperience.value = value === "new" ? "new" : "old";
  try {
    localStorage.setItem(KEY, driverExperience.value);
  } catch (e) {
    // the choice still applies for this visit
  }
}

export function driverHomePath() {
  return driverExperience.value === "new" ? "/driver-new" : "/driver";
}
